import {useEffect, useState} from "react";
import {MdBluetoothSearching, MdDownload, MdSearch, MdWifi} from "react-icons/md";
import Card from "components/card";
import PairingPage from "./PairingPage";


const Filter = () => {

    const [active, setActive] = useState(2);
    let [pairingInstructionInfos, setPairingInstructionInfos] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        //console.log("ID: ", params)
        //console.log(sessionStorage.getItem("productInfoData"))
        if(sessionStorage.getItem("productInfoData")  !== null){
            setPairingInstructionInfos(JSON.parse(sessionStorage.getItem("productInfoData")).pairingInstructionsInfos.sort((a, b) => a.mode - b.mode))
            pairingInstructionInfos = JSON.parse(sessionStorage.getItem("productInfoData")).pairingInstructionsInfos.sort((a, b) => a.mode - b.mode)
        }

        //console.log(pairingInstructionInfos)
        setLoading(false)

    }, []);


    return (
        (!loading &&
            <Card extra={'w-full h-full gap-5 p-2'}>
                <div className="mt-2 flex flex-wrap justify-between pl-[19px] pt-[18px]">
                    <h4 className="text-xl font-semibold text-navy-700 dark:text-white">
                        Pairing Modes
                    </h4>
                    <div className="flex flex-col sm:flex-row justify-between">
                        <button
                            onClick={() => setActive(2)}
                            className={`linear flex items-center justify-center rounded-full border px-4 py-1.5 text-base font-medium text-navy-700 transition duration-200 hover:bg-gray-50 dark:border-none dark:text-white dark:hover:bg-white/10 dark:active:bg-white/20 md:mr-[20px] ${
                                active === 2
                                    ? "border-gray-600 bg-gray-300 dark:!border-none dark:bg-[#004c86]"
                                    : "!border-none"
                            } `}>
                            <MdBluetoothSearching/>
                            &nbsp; Bluetooth
                        </button>

                        <button
                            onClick={() => setActive(0)}
                            className={`linear flex items-center justify-center rounded-full border px-4 py-1.5 text-base font-medium text-navy-700 transition duration-200 hover:bg-gray-50 dark:border-none dark:text-white dark:hover:bg-white/10 dark:active:bg-white/20 md:mr-[20px] ${
                                active === 0
                                    ? "border-gray-600 bg-gray-300 dark:!border-none dark:bg-[#004c86]"
                                    : "!border-none"
                            } `}>
                            <MdWifi/>
                            &nbsp; AP
                        </button>
                        <button
                            onClick={() => setActive(1)}
                            className={`linear flex items-center justify-center rounded-full border px-4 py-1.5 text-base font-medium text-navy-700 transition duration-200 hover:bg-gray-50 dark:border-none dark:text-white dark:hover:bg-white/10 dark:active:bg-white/20 md:mr-[20px] ${
                                active === 1
                                    ? "border-gray-600 bg-gray-300 dark:!border-none dark:bg-[#004c86]"
                                    : "!border-none"
                            } `}
                        >
                            <MdSearch/>
                            &nbsp; Smart Config
                        </button>
                    </div>
                </div>
                {pairingInstructionInfos.length > active ?
                    <PairingPage
                        title={pairingInstructionInfos[active].title}
                        text={pairingInstructionInfos[active].text}
                        image={pairingInstructionInfos[active].instructionUrl}
                        radio={pairingInstructionInfos[active].confirmText}
                        confirm={pairingInstructionInfos[active].buttonText}
                    /> :
                    <PairingPage
                        title= ""
                        text= ""
                        image= ""
                        radio= ""
                        confirm= ""
                    />
                }
            </Card>
        )
    );
};

export default Filter;
